/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from './DiplomatObject';

export const backupSettingsSchema = DiplomatObject.shape({
   backupDir: yup.string(),
   backupOnExit: yup.boolean(),
   encryptBackup: yup.boolean(),
   password: yup.string().when('encryptBackup', {
      is: false,
      then: yup.string(),
      otherwise: yup.string().min(1),
   }),
   dailyBackups: yup.boolean(),
   dailyBackupHour: yup.number().integer().max(23),
   dailyBackupRetention: yup.number().integer().min(1),
   passwordHistory: yup.object(),
});

export type BackupSettings = yup.InferType<typeof backupSettingsSchema>;
